import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.869 2.085a3.612 3.612 0 0 1 5.047 5.047zm-.785.785A3.612 3.612 0 0 0 7.13 7.917zM5 .28a4.722 4.722 0 1 0 0 9.443A4.722 4.722 0 0 0 5 .279",
		clipRule: "evenodd"
	})
});
export default SvgCancel;
